__turbopack_context__.v({
  "ordinalsAddress": "WalletBalanceXverse-module__dCz6ia__ordinalsAddress",
  "paymentsAddress": "WalletBalanceXverse-module__dCz6ia__paymentsAddress",
  "root": "WalletBalanceXverse-module__dCz6ia__root",
});
